// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dR12Ko {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.zF6Zgk {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  flex-shrink: 0;
}

.VDqoRt {
  display: flex;
  align-items: center;
}

.Lg8mEz {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContabilidadeDigital/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;AAChB","sourcesContent":[".layoutContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  flex-shrink: 0;\n}\n\n.rightContent {\n  display: flex;\n  align-items: center;\n}\n\n.routedContent {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutContainer": `dR12Ko`,
	"header": `zF6Zgk`,
	"rightContent": `VDqoRt`,
	"routedContent": `Lg8mEz`
};
module.exports = ___CSS_LOADER_EXPORT___;
